<template>
  <div class="blocked_logs_page">
    <h1>优质主播7日留存表</h1>
    <div class="user-options clearfix">
      <el-date-picker
        v-model="platformData"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="retainedOptions"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select style="width: 160px" v-model="country" placeholder>
        <el-option
          v-for="(item, itemIndex) in countryList"
          v-bind:key="itemIndex + 99"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      <el-input
        style="width: 160px"
        v-model="agentId"
        placeholder="请输入代理id"
      ></el-input>

      <el-button type="primary" @click="get_list" :loading="login1"
        >查询</el-button
      >
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <el-row>
      <el-table :data="tableList" border v-loading="login1">
        <el-table-column align="center" fixed prop="date" label="日期" sortable>
        </el-table-column>
        <el-table-column
          align="center"
          prop="regHostCount"
          label="注册主播数"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="qualityHostCount"
          label="转正主播数"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="activeHostCount"
          label="有效认证主播数（在线时长超过30min）"
          sortable
        >
        </el-table-column>
        <el-table-column align="center" label="2日" sortable>
          <el-table-column
            align="center"
            prop="keepActiveHostCount2"
            label="2日有效留存 主播数"
            sortable
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="lostHostUid2"
            label="2日流失有效主播uid"
            sortable
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="poplet(scope.row.lostHostUid2)"
                >查询</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="3日" sortable>
          <el-table-column
            align="center"
            prop="keepActiveHostCount3"
            label="3日有效留存 主播数"
            sortable
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="lostHostUid3"
            label="3日流失有效主播uid"
            sortable
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="poplet(scope.row.lostHostUid3)"
                >查询</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="4日" sortable>
          <el-table-column
            align="center"
            prop="keepActiveHostCount4"
            label="4日有效留存 主播数"
            sortable
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="lostHostUid4"
            label="4日流失有效主播uid"
            sortable
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="poplet(scope.row.lostHostUid4)"
                >查询</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="5日" sortable>
          <el-table-column
            align="center"
            prop="keepActiveHostCount5"
            label="5日有效留存 主播数"
            sortable
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="lostHostUid5"
            label="5日流失有效主播uid"
            sortable
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="poplet(scope.row.lostHostUid5)"
                >查询</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="6日" sortable>
          <el-table-column
            align="center"
            prop="keepActiveHostCount6"
            label="6日有效留存 主播数"
            sortable
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="lostHostUid6"
            label="6日流失有效主播uid"
            sortable
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="poplet(scope.row.lostHostUid6)"
                >查询</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="7日" sortable>
          <el-table-column
            align="center"
            prop="keepActiveHostCount7"
            label="7日有效留存 主播数"
            sortable
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="lostHostUid7"
            label="7日流失有效主播uid"
            sortable
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="poplet(scope.row.lostHostUid7)"
                >查询</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="30"
      ></el-pagination>
    </el-row>
    <el-dialog
      :visible.sync="dialogVisible_1"
      :before-close="handleClose1"
      width="70%"
    >
      <ATM ref="AAA" @closeSelectGiftDialogs="closeSelectGiftDialogs"></ATM>
    </el-dialog>
  </div>
</template>

<script>
import ATM from './index.vue'
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry } from '@/utils/normalApi.js'
export default {
  components: {
    ATM
  },
  data () {
    return {
      login1: false,
      dialogVisible_1: false,
      platformData: [datainfor(2), datainfor(1)],
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      agentId: '',
      loading: true,
      country: 'total',
      countryList: '',
      page: 1,
      total: 0
    }
  },
  beforeCreate () {},
  created () {
    this.getCountry_()
    this.get_list()
  },
  mounted () {},
  computed: {
    username () {
      return this.$store.getters.username
    },
    userLevel () {
      return this.$store.getters.userLevel
    },
    token () {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async getCountry_ () {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async get_list () {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'post',
        url:
          this.$store.getters.path.quality_keep +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          countryCode: this.country,
          page: this.page
        }
      })
      if (res !== null) {
        this.login1 = false
        this.tableList = res.data.data
        this.total = res.data.total
      }
    },
   
    // 分页
    handleCurrentChange (num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai () {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_timeBox_xlsx,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          isPay: this.isPay,
          userType: this.userType
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, 'Live宝箱奖励数据' + '')
    },
    poplet (num) {
      setTimeout(() => {
        this.$refs.AAA.rid = num
        this.$refs.AAA.getDayChatDetai()
      }, 200)
      this.dialogVisible_1 = true
    },
    closeSelectGiftDialogs () {
      this.dialogVisible_1 = false
    },
    handleClose1 () {
      this.dialogVisible_1 = false
    }
  }
}
</script>

<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
